<template>
  <div class="article-frame">
    <div ref="content" class="article-box article-box-bg">
      <img class="header-img" :src="$getThemeImagePath('useful_link/pc_banner_rule.jpeg')">
      <div class="content pos-relative legal-content">
        <go-to-top />
        <h1 class="main-title">
          プロモーション一般利用規約
        </h1>
        <h2 class="update-time">
          最終更新日：2026年6月18日
        </h2>

        <h3 class="terms-title">
          1. 利用規約と条件
        </h3>
        <p>
          TIGER CASINOのプロモーションへ参加するお客様は、本規約、TIGER CASINO利用規約、各プロモーションページ、告知、メールまたはアカウント内で表示される個別条件に同意したものとみなされます。
        </p>
        <p>
          個別プロモーションに特別な条件がある場合は、その個別条件が優先されます。内容に同意いただけない場合は、プロモーションへの参加をお控えください。
        </p>

        <h3 class="terms-title">
          2. ボーナス
        </h3>
        <p>
          ボーナスとは、お客様のアカウントまたはボーナスウォレットへ付与される特典残高、無料スピン、キャッシュ特典、またはこれらに類するプロモーション特典を指します。ボーナスは原則として直接出金できず、指定された賭け条件、対象ゲーム、有効期限、その他の条件を満たした場合に限り、現金残高へ変換または出金可能となります。
        </p>
        <h4 class="legal-subtitle">
          BONUSウォレット
        </h4>
        <p>
          BONUSウォレットは、特定のプロモーションで付与されるボーナスマネーを管理する専用ウォレットです。現金ウォレットとは分離して管理され、指定された条件を満たすことで現金ウォレットへ移行されます。現金ウォレットへの入出金を行った場合、BONUSウォレット内の未消化ボーナスおよび関連勝利金が失効する場合があります。
        </p>
        <h4 class="legal-subtitle">
          キャッシュボーナス
        </h4>
        <p>
          キャッシュボーナスは、指定された現金ウォレットまたは対象通貨に付与されるプロモーション特典です。適用条件、賭け条件、有効期限、対象ゲームは、各プロモーションで定めます。
        </p>
        <h4 class="legal-subtitle">
          フリースピン
        </h4>
        <p>
          フリースピンは、指定されたスロットゲーム等で利用できる無料スピン特典です。対象ゲーム、有効期限、勝利金の扱い、出金条件は、各プロモーション条件に従います。
        </p>

        <h3 class="terms-title">
          3. 賭け条件
        </h3>
        <p>
          賭け条件とは、ボーナスまたは入金額を出金可能にするために必要なベット倍率を指します。ボーナスを利用しない場合でも、入金分に対して一定の賭け条件が適用される場合があります。
        </p>
        <p>
          各ボーナスの倍率、対象ゲーム、反映率、消化状況は、プロモーションページ、告知、メール、アカウント内表示等で確認できます。賭け条件の管理および達成状況の確認は、お客様ご自身の責任となります。
        </p>
        <p>
          複数のボーナスを保有する場合、それぞれの賭け条件が合算または個別に計算されることがあります。ウォレット残高が一定額未満の状態で新たに入金した場合、未消化条件が消滅する設定を設ける場合があります。詳細は公開前にTIGER CASINOの仕様へ合わせて調整してください。
        </p>

        <h3 class="terms-title">
          4. 賭け条件への反映率
        </h3>
        <p>
          特別な記載がない限り、ゲーム種別ごとの賭け条件反映率は以下を基準とします。
        </p>
        <table class="legal-table">
          <thead>
            <tr>
              <th>ウォレット / ゲーム種別</th>
              <th>反映率</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>BONUSウォレット / スロット</td>
              <td>100%</td>
            </tr>
            <tr>
              <td>BONUSウォレット / ライブカジノ</td>
              <td>20%</td>
            </tr>
          </tbody>
        </table>
        <p>
          対象外ゲーム、禁止ゲーム、除外ゲームが指定されている場合、当該ゲームでのベットは賭け条件へ反映されません。また、禁止ゲームでのプレイ自体が規約違反となる場合があります。
        </p>

        <h3 class="terms-title">
          5. 有効期限
        </h3>
        <p>
          ボーナス、フリースピン、賭け条件には有効期限が設定されます。期限内に条件を満たさない場合、ボーナスおよび関連勝利金は失効または回収される場合があります。
        </p>
        <p>
          標準設定例：
        </p>
        <table class="legal-table">
          <thead>
            <tr>
              <th>特典種別</th>
              <th>有効期限</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>入金不要ボーナス / BONUSウォレット</td>
              <td>付与後30日間</td>
            </tr>
            <tr>
              <td>キャッシュボーナス</td>
              <td>付与後30日間</td>
            </tr>
            <tr>
              <td>フリースピン</td>
              <td>付与後7日間</td>
            </tr>
          </tbody>
        </table>
        <p>
          個別プロモーションに別途記載がある場合は、個別条件を優先します。
        </p>

        <h3 class="terms-title">
          6. 禁止・除外ゲーム
        </h3>
        <p>
          禁止ゲームまたは除外ゲームでプレイした場合、賭け条件に反映されないだけでなく、ボーナス、関連勝利金、プロモーション参加資格が無効となる場合があります。
        </p>
        <p>
          BONUSウォレット利用時の禁止ゲーム例：
        </p>
        <ul class="terms-list">
          <li>パチンコ・パチスロ</li>
          <li>クラッシュゲーム</li>
          <li>ブラックジャック</li>
          <li>ルーレット</li>
          <li>Evolution社のFirst Personシリーズ</li>
        </ul>
        <p>
          キャッシュボーナス、フリースピン、その他プロモーションの禁止・除外ゲームは、各プロモーションページまたは告知で明示します。
        </p>

        <h3 class="terms-title">
          7. ベット額制限
        </h3>
        <p>
          ボーナス利用中は、1回あたりのベット額に上限が設定される場合があります。上限を超えるベットは規約違反となり、ボーナスおよび関連勝利金が無効となる場合があります。
        </p>
        <p>
          BONUSウォレット利用時の標準上限例：
        </p>
        <table class="legal-table">
          <thead>
            <tr>
              <th>ゲーム種別</th>
              <th>1回あたりの上限</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>スロット</td>
              <td>625 JPY / 5 USD</td>
            </tr>
            <tr>
              <td>ライブカジノ</td>
              <td>3,000 JPY / 20 USD</td>
            </tr>
          </tbody>
        </table>
        <p>
          キャッシュボーナスまたはフリースピン由来の勝利金については、個別条件で別途定める場合を除き、ベット額制限を設けない運用とすることがあります。
        </p>

        <h3 class="terms-title">
          8. 出金上限
        </h3>
        <p>
          ボーナスは、指定された条件を満たした後に現金残高へ変換され、出金可能となります。ただし、プロモーションによっては出金上限が設定される場合があります。出金上限がある場合は、プロモーションページ、告知、メール、アカウント内表示等で明示します。
        </p>

        <h3 class="terms-title">
          9. ボーナス乱用と禁止行為
        </h3>
        <p>
          TIGER CASINOは、取引履歴、ゲーム履歴、アカウント情報、決済情報、端末情報、IP情報等を確認し、ボーナス乱用、不正利用、違法なゲームプレイ、共謀、詐欺行為を調査する権利を有します。
        </p>
        <p>
          以下の行為は禁止されます。
        </p>
        <ol class="terms-list">
          <li>複数アカウントまたは第三者との共謀により、ゲーム仕様やプロモーション条件を悪用する行為。</li>
          <li>出金目的で資金や勝利状態をゲーム内に保持し、後から別入金で利益化する行為。</li>
          <li>ストック型スロット、Collect機能、フリースピン蓄積機能等を利用し、条件回避や利益確保を狙う行為。</li>
          <li>ルーレットの赤黒同時ベット、バカラのプレイヤー/バンカー同時ベット等の相反ベット。</li>
          <li>外部ツール、ボット、自動化ソフト、統計支援ツール等を利用したプレイ。</li>
          <li>ボーナス条件を意図的に操作し、不正にベット額または利益を増加させる行為。</li>
          <li>VPN、プロキシ、位置情報偽装等によりリスク判定を回避する行為。</li>
          <li>ボーナス発動条件を意図的にトリガーする、またはゲーム構造を悪用する行為。</li>
        </ol>
        <p>
          違反が疑われる場合、TIGER CASINOは調査完了までアカウント、残高、出金申請、ボーナス、プロモーション参加資格を保留または制限できます。違反が確認された場合、ボーナスおよび関連勝利金の無効化、資金没収、参加資格剥奪、アカウント閉鎖等の措置を講じることがあります。
        </p>

        <h3 class="terms-title">
          10. 準拠法・その他
        </h3>
        <p>
          本規約の準拠法および管轄は、TIGER CASINOのライセンス、運営会社、対象市場に合わせて公開前に設定します。
        </p>
        <p>
          アカウント種別によってはプロモーションへ参加できない場合があります。TIGER CASINOは、プロモーション内容および本規約を事前通知なく変更、停止、終了する権利を有します。変更後の条件は、サイト上または対象プロモーションページに掲載された時点で効力を有します。
        </p>
      </div>
      <!-- content End -->
    </div>
    <!-- article-box End -->
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'

export default {
  name: 'RuleTiger',
  components: {
    goToTop
  },
  data() {
    return {
      content: false,
      isHiddenBox: false,
      isOpen: false,
      isHiddenButton: false
    }
  },
  computed: {
    supportEmail() {
      return process.env.VUE_APP_SUPPORT_EMAIL
    }
  },
  created() {
  },
  methods: {

  }
}
</script>

<style scoped>
/* 段落標題：與上一段拉開距離、貼近自己的內容 */
.terms-title {
  margin-top: 2.5rem;
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
  font-weight: 700;
}

/* 第一個標題不需要上方間距 */
.update-time + .terms-title {
  margin-top: 0;
}

/* 小標題（ウォレット種別など） */
.legal-subtitle {
  margin: 1.25rem 0 0.45rem;
  font-size: 1rem;
  font-weight: 700;
}

/* 段落間距 */
.content p {
  margin: 0 0 1rem;
}

/* 項目清單：黑底上的項目符號改為白色 */
.terms-list {
  margin: 0.5rem 0 1rem 1.5rem;
}

ul.terms-list,
ol.terms-list {
  list-style-position: outside;
  padding-left: 1.4rem;
}

ul.terms-list {
  list-style: disc;
}

ol.terms-list {
  list-style: decimal;
}

.terms-list li {
  margin-bottom: 0.35rem;
}

.terms-list li::marker {
  color: #fff;
}

/* 表格：黑底樣式 */
.legal-table {
  width: 100%;
  border-collapse: collapse;
  margin: 0.75rem 0 1.25rem;
  line-height: 1.7;
}

.legal-table th,
.legal-table td {
  border: 1px solid rgba(255, 255, 255, 0.25);
  padding: 0.65rem 0.8rem;
  vertical-align: top;
}

.legal-table th {
  background: rgba(255, 255, 255, 0.08);
  font-weight: 700;
  text-align: left;
}

@media (max-width: 640px) {
  .legal-table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }
}
</style>
